export const NR1_VALOR_POR_VIDA = 9.9
export const COMISSAO_PADRAO = 0

export type ProjecaoNr1 = {
  vidas: number
  base: number
  nr1: number
  total: number
  sem: number
  com: number
  aum: number
  difMensal: number
  difAnual: number
}

export function calcularProjecaoNr1(
  vidas: number,
  valorIndividual: number,
  comissaoPerc: number,
  nr1ValorPorVida: number = NR1_VALOR_POR_VIDA
): ProjecaoNr1 {
  const rate = (Number.isNaN(comissaoPerc) ? COMISSAO_PADRAO : comissaoPerc) / 100
  const base = vidas * valorIndividual
  const nr1 = vidas * nr1ValorPorVida
  const total = base + nr1
  const sem = base * rate
  const com = total * rate
  const difMensal = com - sem

  return {
    vidas,
    base,
    nr1,
    total,
    sem,
    com,
    aum: sem > 0 ? (difMensal / sem) * 100 : 0,
    difMensal,
    difAnual: difMensal * 12,
  }
}

export const fmtMoeda = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
